import { render, staticRenderFns } from "./ChangePhotoSlidebar.vue?vue&type=template&id=107cc531"
import script from "./ChangePhotoSlidebar.vue?vue&type=script&lang=js"
export * from "./ChangePhotoSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports